import { Component } from '@verndale/core';

class shareSocialMedia extends Component {
  setupDefaults() {
    this.dom = {
      buttons: this.el.querySelectorAll('.share-social-media__link')
    };
    this.url = window.location.href;
  }

  addListeners() {
    Array.from(this.dom.buttons).forEach(button => {
      const socialApi = button.dataset.shareApi;
      button.addEventListener('click', () =>
        this.openModal(socialApi + this.url)
      );
    });
  }

  openModal(url) {
    const winTop = window.innerHeight / 3 - 200;
    const winLeft = window.innerWidth / 2 - 300;

    window.open(
      url,
      'sharer',
      `top=${winTop}, left=${winLeft}, width=600, height=400, scrollbars=no`
    );
  }
}

export default shareSocialMedia;
